import React, { useCallback, useEffect } from 'react';

import { Box } from '@chakra-ui/react';
import { Grid } from '@material-ui/core';
import { PlainTextHeader } from 'Deer/components/HeaderComponents/PlainTextHeader';
import styled from 'styled-components';
import { Container } from 'styles/admin';

import { sendPageViewEvent } from 'constants/mixpanelHelper';

import { ButtonFilled } from 'uiToolkit/Button';
import { TextLabel } from 'uiToolkitV1/Typography';

import CreateCustomRole from './CreateCustomRole/CreateCustomRole';
import {
  CustomRoleContextProvider,
  CUSTOM_ROLE_ACTION_TYPES,
  CUSTOM_ROLE_VIEWS,
  useCustomRoleContext,
} from './CustomRoleContext';
import RoleMemberEditSidePanel from './RoleMemberEditSidePanel';
import RoleMemberTable from './RoleMemberTable';

const StyledContainer = styled(Container)`
  height: auto;
`;

const CustomRoleComponent = () => {
  const {
    state: { currentView, isLoading, isError },
    customRoleDispatch,
  } = useCustomRoleContext();

  const openCreateNewRoleView = useCallback(() => {
    customRoleDispatch({
      type: CUSTOM_ROLE_ACTION_TYPES.openCreateNewView,
      payload: {},
    });
  }, [customRoleDispatch]);

  useEffect(() => {
    sendPageViewEvent({
      eventProperties: {
        source: 'Company-settings-access control',
      },
    });
  }, []);

  // return <CreateCustomRole />;
  return (
    <>
      {currentView === CUSTOM_ROLE_VIEWS.default ? (
        <StyledContainer>
          <Grid container justify="space-between">
            <Grid item>
              <PlainTextHeader>Access control</PlainTextHeader>
              <TextLabel color="text.g2" mb={2}>
                Create custom admin permissions for individuals to view or manage a subset of your company
              </TextLabel>
            </Grid>
            <Grid item>
              <ButtonFilled disabled={isLoading || isError} onClick={openCreateNewRoleView}>
                Create Custom Access
              </ButtonFilled>
            </Grid>
          </Grid>
          <Box borderRadius="8px" boxShadow="0px 0px 2px 0px rgba(0, 0, 0, 0.24)" background="white">
            <RoleMemberTable />
          </Box>
        </StyledContainer>
      ) : (
        <CreateCustomRole />
      )}
      <RoleMemberEditSidePanel />
    </>
  );
};

const CustomRole = () => (
  <CustomRoleContextProvider>
    <CustomRoleComponent />
  </CustomRoleContextProvider>
);

export default CustomRole;
